class AppUrl {


	//static BaseUrl ='http://127.0.0.1:8000/api';
	static BaseUrl ='https://demo.markhambazaar.com/api';
    
    static Videopart = this.BaseUrl+'/homeextra';
    static exploreallDatabyid = this.BaseUrl+'/exploreallDatabyid';
    static exploreeventsallData = this.BaseUrl+'/exploreeventsallData';
    static exploreevents = this.BaseUrl+'/exploreevents';
    static footer = this.BaseUrl+'/footer';
    static clientReview = this.BaseUrl+'/clientReview';
     static Contact = this.BaseUrl+'/contactSend';
     static Vvisitor = this.BaseUrl+'/visitor';
      static VendorReg = this.BaseUrl+'/vendorReg';
  

}

export default AppUrl 
